import { StackSimpleIcon } from '@fronton/icons-react';
import {
  DesignRegistrationPanelStructure,
  PanelActionBlock,
} from 'common/components/design-registration-panel';
import { FLOOR_SCREED_ELEMENT_BLOCK } from '../../floor-screed-constants';

export const FLOOR_SCREED_PANEL_ACTION_BLOCK: PanelActionBlock = {
  elementBlock: FLOOR_SCREED_ELEMENT_BLOCK,
  label: 'Записаться на консультацию',
  variant: 'accent',
};

export const FLOOR_SCREED_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: StackSimpleIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: 'Запишитесь на\u00A0консультацию и\u00A0получите предварительный расчёт стоимости',
    },
    actionBlock: [],
  },
  mobilePanel: {
    mobileButton: {
      label: 'Записаться на консультацию',
      elementBlock: FLOOR_SCREED_ELEMENT_BLOCK,
    },
    content: {
      icon: StackSimpleIcon,
      iconColor: 'text-invert',
      iconType: 'duotone',
      text: 'Запишитесь на\u00A0консультацию и\u00A0получите предварительный расчёт стоимости',
    },
    actionBlock: [],
  },
};
